module.exports = __webpack_public_path__ + "img/popupAd.0c7d3dd1.png";